var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlayCircles(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.9998 40.3337C32.1251 40.3337 40.3332 32.1255 40.3332 22.0003C40.3332 11.8751 32.1251 3.66699 21.9998 3.66699C11.8746 3.66699 3.6665 11.8751 3.6665 22.0003C3.6665 32.1255 11.8746 40.3337 21.9998 40.3337Z",
    fill: "white",
    fillOpacity: 0.42,
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3335 14.667L29.3335 22.0003L18.3335 29.3337V14.667Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayCircles);
export default __webpack_public_path__ + "static/media/play-circles.bd0c0985514fed9922f239749e892255.svg";
export { ForwardRef as ReactComponent };